const groupTargetItemsByContact = (items, existingGroups = []) => {
    const groupsByContact = new Map();

    existingGroups.forEach(group => {
        const contactId = group[0]?.node?.Contact?.[0]?.id;
        if (contactId) {
            groupsByContact.set(contactId, [...group]);
        }
    });

    items.forEach(item => {
        const contactId = item.node.Contact?.[0]?.id;
        if (!contactId) return;

        if (!groupsByContact.has(contactId)) {
            groupsByContact.set(contactId, []);
        }
        groupsByContact.get(contactId).push(item);
    });

    return Array.from(groupsByContact.values());
};

export default groupTargetItemsByContact;
